import React from 'react'
import decodeHtml from '../functions/decodeHtml'
import Translation from '../General/Translation'

const Actors = ({actors, translation}) => {

    if(!actors) {
        return ''
    }

    const filteredActors = _.filter(actors, actor => {
        return actor.name !== null
    })

    const length = filteredActors.length

    if(length === 0 ) {
        return ''
    } 

    if(length === 1) {
        return (
            <span className={'text-light'}>
                {decodeHtml(filteredActors[0].name)}
            </span>
        )
    }

    if(length === 2) {
        return (
            <span className={'text-light'}>
                {decodeHtml(filteredActors[0].name)} <Translation id="and" trans={translation}>und</Translation> {decodeHtml(filteredActors[1].name)}
            </span>
        )
    }

    if(length > 2) {
        return (
            <span className={'text-light'}>
                {decodeHtml(filteredActors[0].name)}, {decodeHtml(filteredActors[1].name)} <Translation id="and" trans={translation}>und</Translation> {decodeHtml(filteredActors[2].name)}
            </span>
        )
    }
}

export default Actors